import { PATHS } from "core/consts/pages";

/** Redirect path for doctor-only dashboard access. Used by PatientRouteLayout and Router. */
export const doctorDashboardRedirectPath = "/app/clinic/dashboard";
export const defaultRedirectPath = "/app/clinic/dashboard/todo/active";
export const dtaApproverPath = "/app/clinic/dashboard/rehab-forms-approval";
export const onpremDebugRedirectPath = "/app/clinic/dashboard/onpremsetup/test";
export const predictRedirectPath = "/app/clinic/dashboard/predict";
export const aiChatRedirectPath = PATHS.APP.CHAT;
export const reportPath = "/app/clinic/dashboard/report";
export const userManagementRedirectPath = "/app/clinic/dashboard/users";
